import {Dialog, NavList} from '@superweb/ui'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {FC} from 'react'

import type {TariffsCountry} from '../../../../../api'
import {useCountriesModal} from '../../lib'

type Props = {
  countries: TariffsCountry[]
}

export const CountryModal: FC<Props> = ({countries}) => {
  const i18n = useI18n()
  const {closeModal, isOpened, navListCountries} = useCountriesModal(countries)

  if (!isOpened) return null

  return (
    <Dialog
      content={<NavList items={navListCountries} />}
      onClose={closeModal}
      size="s"
      title={i18n('tariffs-v3.header.country-modal.title', 'Выберите страну')}
      variant="window"
    />
  )
}
